<template>
  <v-content>
    <br>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9" md="5" lg="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Giser Uniformes</v-toolbar-title>
            </v-toolbar>
            <v-row align="center" justify="center">
              <p style="margin-top: 4%;">Bienvenidos</p>
              <v-col cols="12" sm="12" md="12" align="center" justify="center">
                <v-img src="../assets/logo-giser.png" alt="" width="300" height="100"></v-img>
              </v-col>
            </v-row>

            <v-card-text>
              <v-form>
                <v-text-field label="Usuario" name="login" v-model="name" prepend-icon="mdi-account" type="text">
                </v-text-field>
                <v-text-field label="Contraseña" name="password" v-model="pass" prepend-icon="mdi-lock"
                  :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'" @keyup.enter="log()"
                  :type="showPass ? 'text' : 'password'" @click:append="showPass = !showPass">
                </v-text-field>
                <!-- <div id="turnstile-container"></div> -->
              </v-form>
              <v-btn color="primary" @click="log()" style="margin-top: 4%;">Entrar</v-btn>
            </v-card-text>
            <v-card-actions>
              v{{ $version }}
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="log2">Recuperar Contraseña</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="clave" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Recuperar cuenta {{ name }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                En caso de existir se enviara un enlace a su dirección de correo con una vigencia de 5 minutos para
                restablecer su contraseña.
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="cancelar">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="solicitarCodigo">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-content>
</template>

<script>
import swal from 'sweetalert';
import axios from 'axios';
import api from '../conf/ruta-base';
import router from '../router';
import store from '../store';
import UserProfile from '../data';
import posthog from "posthog-js";
import { getPublicIP, host } from '../tools';
export default {
  name: 'Login',
  data: function () {
    return {
      name: '', pass: '', showPass: false, clave: false, codigo: null, codusr: null, idusr: null,
      // turnstileToken: null,
      // turnstileWidgetId: null,
    }
  },
  props: {
    msg: String
  },
  methods: {

    log() {
      // if(!this.turnstileToken){
      //   swal('','Debe completar el desafio','error');
      //   return null
      // }
      if (this.name.length > 3 & this.pass.length > 0) {
        const credentials = {
          username: this.name, password: this.pass,
          // captcha: this.turnstileToken
        }
        axios
          .post(api.api + '/auth/log', { credentials: btoa(JSON.stringify(credentials)) })
          .then(response => {
            if (response.status === 200) {
              console.log("salvamos el token");
              sessionStorage.setItem("token", response.data.access_token);
              sessionStorage.setItem("refress_token", response.data.refress_token);
              UserProfile.setUserData(response.data);
              router.push('/dashboard')
            } else {
              swal('', 'Usuario o contraseña no validos', 'error');
            }
          })
          .catch(error => {
            swal('', 'Usuario o contraseña no validos', 'error');
            store.commit("loading", false);
          })
          .finally()
      } else {
        swal('Favor ingrese usuario y clave validos');

      }
    },
    log2() {
      if (this.name.length < 3) {
        swal('', `Es necesario su usuario para recuperar su contraseña`, 'error')
        return null
      }
      this.clave = true
    },
    cambiarClave() {
      if (this.codigo && this.codusr && this.codigo == this.codusr) {
        axios
          .get(api.api + 'auth/reset/' + this.idusr)
          .then(r => {
            if (r.data.c = 'success') {
              swal('', r.data.mensaje, 'success')
              this.codigo = null
              this.clave = false
            } else if (r.data.c = 'error') {
              swal('', r.data.mensaje, 'error')
              this.codigo = null
              this.clave = false
            }
          })
          .catch(error => {
            console.log(error);
          })
      } else {
        swal('', 'No hemos podido validar el codigo ingresado', 'error')
      }
    },
    solicitarCodigo() {
      axios
        .post(api.api + '/users/verify-user', {
          host: host(),
          username: this.name,
        })
        .finally(() => this.cancelar());
    },
    cancelar() {
      this.codigo = null
      this.clave = false
      this.codusr = null
      this.idusr = null
    }
  },
  created() {
    sessionStorage.clear();
    getPublicIP();
    this.$vuetify.theme.dark = false

  },
  mounted() {
    // this.turnstileWidgetId = window.turnstile.render('#turnstile-container', {
    //   sitekey: '0x4AAAAAAA9nPHaXd7SAaz--',
    //   callback: (token) => {
    //     this.turnstileToken = token;
    //   },
    // });
  },
}
</script>
<style>
#turnstile-container {
  margin: 0 auto;
  /* Centra horizontalmente */
  width: 300px;
  /* Ancho del contenedor (ajústalo según necesites) */
}
</style>